import React, { useState, useEffect } from 'react'
import { FaPlus, FaRegTrashAlt, FaTrash } from 'react-icons/fa'
import NumberFormat from 'react-number-format'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { TabPanel } from 'primereact/tabview'
import {
  Btn,
  BtnIcon,
  CustomDataTableHeader,
  CustomTabView,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
  NumeroDecimal,
  SectionTitle,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'

import { getUfs } from '../../../../../services/api/https/system/system.http'
import { getSeguradoras } from '../../../../../services/api/https/registration/seguradora.http'
import { getVeiculos } from '../../../../../services/api/https/registration/veiculo.http'
import { getMotoristas } from '../../../../../services/api/https/registration/motorista.http'
import {
  getDocumentosRotaMdfe,
  getRotaParaMdfe,
  getVeiculoSugeridoMdfe,
} from '../../../../../services/api/https/deliveries/mdfe.http'
import { getEmissoresByTps } from '../../../../../services/api/https/settings/emissor-cte.http'
import ModalVincularCiot from '../../Ciot/ModalVincularCiot'
import ModalVincularMdfeRota from './ModalVincularMdfeRota'
import {
  NOMES_STATUS_MDFE,
  NOMES_TIPO_EMITENTE_MDFE,
  STATUS_MDFE_VIGENTE,
  normalizarDocumento,
} from '../../Ciot/ciot.util'

export const TIPOS_CARGA = [
  { label: 'Granel Sólido (01)', value: '01' },
  { label: 'Granel Líquido (02)', value: '02' },
  { label: 'Frigorificada (03)', value: '03' },
  { label: 'Conteinerizada (04)', value: '04' },
  { label: 'Carga Geral (05)', value: '05' },
  { label: 'Neogranel (06)', value: '06' },
  { label: 'Perigosa - Granel Sólido (07)', value: '07' },
  { label: 'Perigosa - Granel Líquido (08)', value: '08' },
  { label: 'Perigosa - Frigorificada (09)', value: '09' },
  { label: 'Perigosa - Conteinerizada (10)', value: '10' },
  { label: 'Perigosa - Carga Geral (11)', value: '11' },
]

export const TIPOS_VALE_PEDAGIO = [
  { label: 'TAG (01)', value: '01' },
  { label: 'Leitura de Placa (04)', value: '04' },
]

export const CATEGORIAS_COMBINACAO_VEICULAR = [
  { label: 'Veículo Comercial 2 eixos (02)', value: '02' },
  { label: 'Veículo Comercial 3 eixos (04)', value: '04' },
  { label: 'Veículo Comercial 4 eixos (06)', value: '06' },
  { label: 'Veículo Comercial 5 eixos (07)', value: '07' },
  { label: 'Veículo Comercial 6 eixos (08)', value: '08' },
  { label: 'Veículo Comercial 7 eixos (10)', value: '10' },
  { label: 'Veículo Comercial 8 eixos (11)', value: '11' },
]

const DOCUMENTOS_RESPONSAVEL = [
  { label: 'CNPJ', value: 'cnpj' },
  { label: 'CPF', value: 'cpf' },
]

const TIPOS_EMITENTE_NFE = [
  { label: 'Transportador de carga própria (2)', value: '2' },
  { label: 'Prestador de serviço que emitirá CT-e posteriormente (3)', value: '3' },
]

const RESPONSAVEIS_SEGURO = [
  { label: 'Emitente do MDFe', value: '1' },
  { label: 'Contratante do serviço', value: '2' },
]

const novoCiot = () => ({ ciot: '', tipo_documento_responsavel: 'cnpj', documento_responsavel: '' })

const documentosIniciais = () => ({ modo: 'nfe', nfsRemovidas: [], ctesRemovidos: [] })

const novoValePedagio = () => ({
  cnpj_empresa_fornecedora: '',
  tipo_documento_responsavel: 'cnpj',
  documento_responsavel: '',
  numero_comprovante_compra: '',
  valor_vale_pedagio: null,
  tipo_vale_pedagio: null,
  categoria_combinacao_veicular: null,
})

const inicialState = {
  uf_inicio: null,
  uf_fim: null,
  seguradora: null,
  veiculo: null,
  motorista: null,
  emissor: null,
  tipo_emitente: null,
  numero_apolice: '',
  numero_averbacao: '',
  responsavel_seguro: '1',
  seguro_tipo_documento_responsavel: 'cnpj',
  seguro_documento_responsavel: '',
  tipo_carga: null,
  observacoes: '',
  ciots: [novoCiot()],
  vale_pedagio: novoValePedagio(),
}

const somenteDigitos = (value, max) => value.replace(/\D/g, '').slice(0, max)

const notaSecaoOpcional = texto => (
  <span style={{ fontSize: '0.8rem', color: '#888' }}>{texto}</span>
)

const notaAviso = texto => (
  <div
    style={{
      marginTop: 10,
      padding: '8px 12px',
      borderRadius: 3,
      background: '#FFF3CD',
      border: '1px solid #FFEEBA',
      color: '#856404',
      fontSize: '0.85rem',
    }}
  >
    {texto}
  </div>
)

const ciotPreenchido = ciot => Boolean(ciot.ciot || ciot.documento_responsavel)

const rotuloMdfe = mdfe => (mdfe.numero ? `nº ${mdfe.numero}` : `ref. ${mdfe.ref}`)

const ABA_DOCUMENTOS = 1
const LINHAS_DOCUMENTOS = 10

export default function ModalEmitirMdfe({
  isVisible,
  ctes,
  onClose,
  onSave,
  onError,
  selectedTp,
  origem = 'cte',
  fleetId = null,
  onMdfeVinculado = null,
}) {
  // Hooks
  const [state, setState] = useState(inicialState)
  const [emissores, setEmissores] = useState()
  const [rotaInfo, setRotaInfo] = useState(null)
  const [ufs, setUfs] = useState()
  const [seguradoras, setSeguradoras] = useState()
  const [veiculos, setVeiculos] = useState()
  const [motoristas, setMotoristas] = useState()
  const [sugestaoRota, setSugestaoRota] = useState(null)
  const [opcoesRota, setOpcoesRota] = useState([])
  const [documentos, setDocumentos] = useState(documentosIniciais())
  const [mdfesRota, setMdfesRota] = useState([])
  const [modalCiot, setModalCiot] = useState(false)
  const [modalVincularMdfe, setModalVincularMdfe] = useState(false)
  const [abaAtiva, setAbaAtiva] = useState(0)
  const [filtroDocumentos, setFiltroDocumentos] = useState('')
  const [primeiraLinhaDocumentos, setPrimeiraLinhaDocumentos] = useState(0)

  useEffect(() => {
    const fetchUFs = async () => {
      await getUfs()
        .then(ufs => {
          setUfs(ufs)
        })
        .catch(err => onError(err))
    }
    fetchUFs()
  }, [])

  useEffect(() => {
    const fetchSeguradoras = async () => {
      await getSeguradoras(selectedTp)
        .then(seguradoras => {
          setSeguradoras(seguradoras)
        })
        .catch(err => onError(err))
    }

    const fetchVeiculosMotoristas = async () => {
      await Promise.all([getVeiculos(selectedTp), getMotoristas(selectedTp)])
        .then(([veiculos, motoristas]) => {
          setVeiculos(veiculos.filter(v => v.actived))
          setMotoristas(motoristas.filter(m => m.actived))
        })
        .catch(err => onError(err))
    }

    const fetchEmissores = async () => {
      await getEmissoresByTps(selectedTp)
        .then(emissores => setEmissores(emissores))
        .catch(err => onError(err))
    }

    if (selectedTp) {
      fetchSeguradoras()
      fetchVeiculosMotoristas()
      fetchEmissores()
    }
  }, [selectedTp, origem])

  useEffect(() => {
    if (!isVisible) return
    setState({ ...inicialState, ciots: [novoCiot()], vale_pedagio: novoValePedagio() })
    setSugestaoRota(null)
    setOpcoesRota([])
    setRotaInfo(null)
    setDocumentos(documentosIniciais())
    setMdfesRota([])
    setModalCiot(false)
    setModalVincularMdfe(false)
    setAbaAtiva(0)
    setFiltroDocumentos('')
    setPrimeiraLinhaDocumentos(0)

    if (origem === 'nfe' && fleetId) {
      getRotaParaMdfe(fleetId)
        .then(info => {
          setRotaInfo(info)
          setMdfesRota(info.mdfes || [])
        })
        .catch(err => onError(err))
    } else if (ctes && ctes.length) {
      getVeiculoSugeridoMdfe(ctes.map(c => c.id))
        .then(({ sugestao, opcoes }) => {
          setSugestaoRota(sugestao)
          setOpcoesRota(opcoes || [])
          if (sugestao && sugestao.fleet_id)
            return getDocumentosRotaMdfe(sugestao.fleet_id).then(docs =>
              setMdfesRota(docs.mdfes || []),
            )
          return null
        })
        .catch(err => onError(err))
    }
  }, [isVisible])

  useEffect(() => {
    if (!rotaInfo || !veiculos || !motoristas || !ufs) return
    setState(prevState => {
      if (prevState.veiculo || prevState.motorista) return prevState
      return {
        ...prevState,
        veiculo: veiculos.find(v => v.id === rotaInfo.vehicle_id) || null,
        motorista: motoristas.find(m => m.id === rotaInfo.driver_id) || null,
        uf_inicio: ufs.find(u => u.uf === rotaInfo.uf_inicio) || null,
        uf_fim: rotaInfo.uf_fim ? ufs.find(u => u.uf === rotaInfo.uf_fim) || null : null,
      }
    })
  }, [rotaInfo, veiculos, motoristas, ufs])

  useEffect(() => {
    if (origem !== 'nfe' || !emissores) return
    setState(prevState => {
      const emissor = prevState.emissor || (emissores.length === 1 ? emissores[0] : null)
      if (!emissor) return prevState
      let tipo_emitente = prevState.tipo_emitente
      if (!tipo_emitente && rotaInfo) {
        const cnpjEmissor = String(emissor.cnpj || '').replace(/\D/g, '')
        const ehEmitenteDasNfs = (rotaInfo.companies_cnpjs || []).includes(cnpjEmissor)
        tipo_emitente = TIPOS_EMITENTE_NFE.find(t => t.value === (ehEmitenteDasNfs ? '2' : '3'))
      }
      return { ...prevState, emissor, tipo_emitente }
    })
  }, [origem, emissores, rotaInfo])

  // Pré-seleciona veículo/condutor da rota quando a sugestão é única
  useEffect(() => {
    if (!sugestaoRota || !veiculos || !motoristas) return
    setState(prevState => {
      if (prevState.veiculo || prevState.motorista) return prevState
      return {
        ...prevState,
        veiculo: veiculos.find(v => v.id === sugestaoRota.vehicle_id) || null,
        motorista: motoristas.find(m => m.id === sugestaoRota.driver_id) || null,
      }
    })
  }, [sugestaoRota, veiculos, motoristas])

  // Events
  const onCiotChange = (index, campo, value) => {
    setState(prevState => {
      const ciots = prevState.ciots.map((ciot, i) =>
        i === index ? { ...ciot, [campo]: value } : ciot,
      )
      return { ...prevState, ciots }
    })
  }

  const onAdicionarCiot = () => {
    setState(prevState => ({ ...prevState, ciots: [...prevState.ciots, novoCiot()] }))
  }

  const onEmitirVincularCiot = () => {
    if (modoCte && !ctesSelecionados.length) {
      onError('Mantenha ao menos um CTe nos Documentos associados antes de emitir o CIOT')
      return
    }
    if (!state.veiculo) {
      onError('Rota: selecione o Veículo antes de emitir o CIOT')
      return
    }
    setModalCiot(true)
  }

  // O responsável pelo CIOT no MDF-e é quem o declarou, que pode ser outro emissor do TP
  const onCiotVinculado = (ciot, emissorDoCiot) => {
    setModalCiot(false)
    setState(prevState => {
      const linha = {
        ciot: ciot.numero,
        tipo_documento_responsavel: 'cnpj',
        documento_responsavel: normalizarDocumento(emissorDoCiot.cnpj),
        ciot_id: ciot.id,
      }
      const ciots = prevState.ciots.filter(
        item => ciotPreenchido(item) && item.ciot !== ciot.numero,
      )
      return { ...prevState, ciots: [...ciots, linha] }
    })
  }

  const onRemoverDocumento = (lista, id) =>
    setDocumentos(prev => ({ ...prev, [lista]: [...prev[lista], id] }))

  const onRestaurarDocumentos = () => {
    setDocumentos(prev => ({ ...prev, nfsRemovidas: [], ctesRemovidos: [] }))
    setPrimeiraLinhaDocumentos(0)
  }

  const onModoDocumentosChange = modo => {
    setDocumentos(prev => ({ ...prev, modo }))
    setFiltroDocumentos('')
    setPrimeiraLinhaDocumentos(0)
  }

  const onRemoverCiot = index => {
    setState(prevState => ({
      ...prevState,
      ciots: prevState.ciots.filter((_, i) => i !== index),
    }))
  }

  const onValePedagioChange = (campo, value) => {
    setState(prevState => ({
      ...prevState,
      vale_pedagio: { ...prevState.vale_pedagio, [campo]: value },
    }))
  }

  const onLimparValePedagio = () => {
    setState(prevState => ({ ...prevState, vale_pedagio: novoValePedagio() }))
  }

  // Helpers
  const modoCte = origem === 'cte' || documentos.modo === 'cte'
  const nfsRota = (rotaInfo && rotaInfo.nfes) || []
  // O MDF-e lista cada NF-e pela chave de acesso: nota sem chave nem entra na tabela
  const nfsSemChave = nfsRota.filter(nf => !nf.tem_chave)
  const nfsLivres = nfsRota.filter(nf => nf.tem_chave && !nf.mdfe_vigente)
  const nfsEmOutroMdfe = nfsRota.filter(nf => nf.mdfe_vigente)
  const nfsSelecionadas = nfsLivres.filter(nf => !documentos.nfsRemovidas.includes(nf.delivery_id))
  const ctesRotaLivres = ((rotaInfo && rotaInfo.ctes) || []).filter(cte => !cte.mdfe_vigente)
  const idCte = cte => (origem === 'cte' ? cte.id : cte.cte_id)
  const ctesBase = origem === 'cte' ? ctes || [] : ctesRotaLivres
  const ctesSelecionados = ctesBase.filter(cte => !documentos.ctesRemovidos.includes(idCte(cte)))
  const emissoresDosCtes = Array.from(new Set(ctesSelecionados.map(cte => cte.emissor_id)))
  const emissorMdfe = modoCte
    ? (emissores || []).find(emissor => emissor.id === emissoresDosCtes[0]) || null
    : state.emissor
  const qtdRemovidos = modoCte ? documentos.ctesRemovidos.length : documentos.nfsRemovidas.length
  const nfsDoCte = cte =>
    nfsRota
      .filter(nf => (cte.deliveries_ids || []).includes(nf.delivery_id))
      .map(nf => nf.identifier)
      .join(', ')
  const mdfesAnteriores = mdfesRota.filter(mdfe =>
    [...STATUS_MDFE_VIGENTE, 'encerrado'].includes(mdfe.status),
  )

  const temValePedagioPreenchido = () => {
    const vp = state.vale_pedagio
    return Boolean(
      vp.cnpj_empresa_fornecedora ||
      vp.documento_responsavel ||
      vp.numero_comprovante_compra ||
      vp.valor_vale_pedagio ||
      vp.tipo_vale_pedagio ||
      vp.categoria_combinacao_veicular,
    )
  }

  // A SEFAZ só exige o seguro da carga para emitente prestador; carga própria (2) pode emitir sem seguro
  const seguroObrigatorio = modoCte || !state.tipo_emitente || state.tipo_emitente.value !== '2'

  // Carga própria (2) com veículo próprio não informa o tipo de transportador, e a SEFAZ não exige CIOT
  const ciotDispensado =
    !seguroObrigatorio && Boolean(state.veiculo) && state.veiculo.category === 'Proprio'

  const temSeguroPreenchido = () =>
    Boolean(
      state.seguradora ||
      state.numero_apolice.trim() ||
      state.numero_averbacao.trim() ||
      (state.responsavel_seguro === '2' && state.seguro_documento_responsavel),
    )

  const validar = () => {
    if (modoCte) {
      if (!ctesSelecionados.length) return 'Documentos associados: mantenha ao menos um CTe no MDFe'
      if (emissoresDosCtes.length > 1)
        return 'Os CTes pertencem a Emissores diferentes. Remova os de outro Emissor ou emita um MDFe por Emissor'
      if (!emissorMdfe) return 'Emissor dos CTes não encontrado para o TP selecionado'
    } else {
      if (!state.emissor) return 'Rota: o campo Emissor é obrigatório'
      if (!state.tipo_emitente) return 'Rota: o campo Tipo de Emitente é obrigatório'
      if (rotaInfo && !nfsSelecionadas.length)
        return nfsLivres.length
          ? 'Documentos associados: mantenha ao menos uma NF no MDFe'
          : 'Documentos associados: nenhuma NF da rota pode entrar no MDFe (sem chave de acesso ou já vinculada a outro MDFe)'
    }

    // Rota
    if (!state.veiculo) return 'Rota: o campo Veículo é obrigatório'
    if (!state.motorista) return 'Rota: o campo Condutor é obrigatório'
    if (!state.tipo_carga) return 'Rota: o campo Tipo de Carga é obrigatório'
    if (!state.uf_inicio) return 'Rota: o campo Estado Inicial é obrigatório'
    if (!state.uf_fim) return 'Rota: o campo Estado Final é obrigatório'

    // Seguro
    if (seguroObrigatorio || temSeguroPreenchido()) {
      const complemento = seguroObrigatorio ? '' : ' quando algum dado do seguro é informado'
      if (!state.seguradora) return `Seguro: o campo Seguradora é obrigatório${complemento}`
      if (!state.numero_apolice.trim())
        return `Seguro: o campo Número Apólice é obrigatório${complemento}`
      if (state.responsavel_seguro === '2') {
        if (
          state.seguro_tipo_documento_responsavel === 'cnpj' &&
          state.seguro_documento_responsavel.length !== 14
        )
          return 'Seguro: o CNPJ do Responsável pelo Seguro deve conter 14 dígitos'
        if (
          state.seguro_tipo_documento_responsavel === 'cpf' &&
          state.seguro_documento_responsavel.length !== 11
        )
          return 'Seguro: o CPF do Responsável pelo Seguro deve conter 11 dígitos'
      }
    }

    // Vale Pedágio
    if (temValePedagioPreenchido()) {
      const vp = state.vale_pedagio
      if (vp.cnpj_empresa_fornecedora.length !== 14)
        return 'Vale Pedágio: o CNPJ da Empresa Fornecedora deve conter 14 dígitos'
      if (vp.tipo_documento_responsavel === 'cnpj' && vp.documento_responsavel.length !== 14)
        return 'Vale Pedágio: o CNPJ do Responsável pelo Pagamento deve conter 14 dígitos'
      if (vp.tipo_documento_responsavel === 'cpf' && vp.documento_responsavel.length !== 11)
        return 'Vale Pedágio: o CPF do Responsável pelo Pagamento deve conter 11 dígitos'
      if (!vp.numero_comprovante_compra)
        return 'Vale Pedágio: o campo Número do Comprovante (IDVPO) é obrigatório'
      if (!vp.valor_vale_pedagio || Number(vp.valor_vale_pedagio) <= 0)
        return 'Vale Pedágio: informe um Valor maior que zero'
    }

    if (state.observacoes && state.observacoes.length > 2000)
      return 'O campo Observações deve conter no máximo 2000 caracteres'

    // CIOT
    const codigos = new Set()
    for (let i = 0; i < state.ciots.length; i++) {
      if (!ciotPreenchido(state.ciots[i])) continue
      const { ciot, tipo_documento_responsavel, documento_responsavel } = state.ciots[i]
      if (ciot.length !== 12) return `CIOT ${i + 1}: o código deve conter 12 dígitos`
      if (codigos.has(ciot)) return `CIOT ${i + 1}: código duplicado`
      codigos.add(ciot)
      if (tipo_documento_responsavel === 'cnpj' && documento_responsavel.length !== 14)
        return `CIOT ${i + 1}: o CNPJ do responsável deve conter 14 dígitos`
      if (tipo_documento_responsavel === 'cpf' && documento_responsavel.length !== 11)
        return `CIOT ${i + 1}: o CPF do responsável deve conter 11 dígitos`
    }
    return null
  }

  const onBtnSalvarClicked = async () => {
    const erro = validar()
    if (erro) {
      if (/^(Documentos associados|Os CTes)/.test(erro)) setAbaAtiva(ABA_DOCUMENTOS)
      onError(erro)
      return
    }

    const vp = state.vale_pedagio
    onSave({
      ...(modoCte
        ? {
            document_origin: 'cte',
            ctes_ids: ctesSelecionados.map(idCte),
            emissor_id: emissoresDosCtes[0],
            ...(origem === 'nfe' ? { fleet_id: fleetId } : {}),
          }
        : {
            document_origin: 'nfe',
            fleet_id: fleetId,
            emissor_id: state.emissor.id,
            tipo_emitente: state.tipo_emitente.value,
            deliveries_ids: nfsSelecionadas.map(nf => nf.delivery_id),
          }),
      uf_inicio: state.uf_inicio.uf,
      uf_fim: state.uf_fim.uf,
      vehicle_id: state.veiculo.id,
      driver_id: state.motorista.id,
      numero_apolice: state.numero_apolice.trim(),
      numero_averbacao: state.numero_averbacao.trim(),
      seguradora_id: state.seguradora ? state.seguradora.id : null,
      responsavel_seguro: state.responsavel_seguro,
      seguro_tipo_documento_responsavel:
        state.responsavel_seguro === '2' ? state.seguro_tipo_documento_responsavel : null,
      seguro_documento_responsavel:
        state.responsavel_seguro === '2' ? state.seguro_documento_responsavel : null,
      tipo_carga: state.tipo_carga.value,
      observacoes: state.observacoes ? state.observacoes.trim() : null,
      vale_pedagio: temValePedagioPreenchido()
        ? {
            cnpj_empresa_fornecedora: vp.cnpj_empresa_fornecedora,
            tipo_documento_responsavel: vp.tipo_documento_responsavel,
            documento_responsavel: vp.documento_responsavel,
            numero_comprovante_compra: vp.numero_comprovante_compra,
            valor_vale_pedagio: Number(vp.valor_vale_pedagio),
            tipo_vale_pedagio: vp.tipo_vale_pedagio ? vp.tipo_vale_pedagio.value : null,
            categoria_combinacao_veicular: vp.categoria_combinacao_veicular
              ? vp.categoria_combinacao_veicular.value
              : null,
          }
        : null,
      ciots: state.ciots.filter(ciotPreenchido).map(ciot => ({
        ciot: ciot.ciot,
        tipo_documento_responsavel: ciot.tipo_documento_responsavel,
        documento_responsavel: ciot.documento_responsavel,
        ...(ciot.ciot_id ? { ciot_id: ciot.ciot_id } : {}),
      })),
    })
  }

  const renderCampoDocumentoResponsavel = ({
    radioName,
    label,
    tipo,
    documento,
    onChangeTipo,
    onChangeDocumento,
    disabled = false,
  }) => (
    <div style={{ marginTop: 10, textAlign: 'left' }}>
      <label style={{ fontSize: '0.8rem', color: '#14B0BF', display: 'block' }}>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 3 }}>
        {DOCUMENTOS_RESPONSAVEL.map(doc => (
          <label
            key={doc.value}
            style={{
              marginBottom: 0,
              fontSize: '0.9rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <input
              type="radio"
              name={radioName}
              disabled={disabled}
              checked={tipo === doc.value}
              onChange={() => onChangeTipo(doc.value)}
              style={{ marginRight: 4 }}
            />
            {doc.label}
          </label>
        ))}
        <NumberFormat
          style={{
            flex: 1,
            minWidth: 0,
            outline: 'none',
            border: '1px solid #F1F1F1',
            borderRadius: 3,
            height: 30,
            padding: 10,
          }}
          format={tipo === 'cnpj' ? '##.###.###/####-##' : '###.###.###-##'}
          isNumericString={true}
          disabled={disabled}
          value={documento}
          placeholder={tipo === 'cnpj' ? '00.000.000/0000-00' : '000.000.000-00'}
          onValueChange={({ value }) => {
            if (value !== documento) onChangeDocumento(value)
          }}
        />
      </div>
    </div>
  )

  const avisoMdfeAnterior = mdfe => {
    const tipo = NOMES_TIPO_EMITENTE_MDFE[mdfe.tipo_emitente] || 'tipo de emitente não informado'
    if (mdfe.status === 'encerrado')
      return `Esta rota já teve o MDFe ${rotuloMdfe(mdfe)} (${tipo}), encerrado. Um novo MDFe pode ser emitido normalmente.`
    return (
      `Esta rota já tem o MDFe ${rotuloMdfe(mdfe)} (${tipo}), ${NOMES_STATUS_MDFE[mdfe.status]}. ` +
      'Outro MDFe para a rota só pode ter tipo de emitente ou emissor diferente (rota mista); ' +
      'para substituí-lo, cancele ou encerre o atual.'
    )
  }

  const contextoCiot = {
    tpId: origem === 'cte' && ctes && ctes[0] ? ctes[0].tp_id || selectedTp : null,
    fleetId: origem === 'nfe' ? fleetId : (sugestaoRota && sugestaoRota.fleet_id) || null,
    placa: state.veiculo ? state.veiculo.vehicle_badge : null,
    ctesIds: modoCte ? ctesSelecionados.map(idCte) : [],
    deliveriesIds: modoCte ? [] : nfsSelecionadas.map(nf => nf.delivery_id),
    vehicleId: state.veiculo ? state.veiculo.id : null,
    tipoCarga: state.tipo_carga ? Number(state.tipo_carga.value) : null,
  }

  const linhasDocumentos = modoCte ? ctesSelecionados : nfsSelecionadas
  // Remover a última linha da última página não pode deixar a tabela numa página vazia
  const primeiraLinhaValida =
    primeiraLinhaDocumentos < linhasDocumentos.length
      ? primeiraLinhaDocumentos
      : Math.max(
          0,
          (Math.ceil(linhasDocumentos.length / LINHAS_DOCUMENTOS) - 1) * LINHAS_DOCUMENTOS,
        )

  const propsTabelaDocumentos = {
    paginator: true,
    rows: LINHAS_DOCUMENTOS,
    first: primeiraLinhaValida,
    onPage: evento => setPrimeiraLinhaDocumentos(evento.first),
    globalFilter: filtroDocumentos,
    emptyMessage: 'Nenhum documento neste MDFe',
    header: (
      <CustomDataTableHeader
        value={filtroDocumentos}
        onChange={valor => {
          setFiltroDocumentos(valor)
          setPrimeiraLinhaDocumentos(0)
        }}
      />
    ),
  }

  const botaoRemover = (lista, id) => (
    <BtnIcon onClick={() => onRemoverDocumento(lista, id)}>
      <FaRegTrashAlt color="red" size={18} />
    </BtnIcon>
  )

  const renderTabelaDocumentos = () => {
    if (!modoCte)
      return (
        <DataTable value={nfsSelecionadas} {...propsTabelaDocumentos}>
          <Column field="identifier" header="NF" style={tableCellCentered(110)} />
          <Column field="empresa" header="Empresa" />
          <Column field="cliente" header="Cliente" />
          <Column
            field="cidade"
            header="Cidade"
            style={tableCellCentered(150)}
            body={nf => (nf.cidade ? `${nf.cidade}/${nf.uf}` : '')}
          />
          <Column
            header="Peso (kg)"
            style={tableCellCentered(100)}
            body={nf => <NumeroDecimal>{nf.peso}</NumeroDecimal>}
          />
          <Column
            style={tableCellCentered(60)}
            body={nf => botaoRemover('nfsRemovidas', nf.delivery_id)}
          />
        </DataTable>
      )
    if (origem === 'nfe')
      return (
        <DataTable value={ctesSelecionados} {...propsTabelaDocumentos}>
          <Column field="numero" header="CTe" style={tableCellCentered(110)} />
          <Column header="NFs" body={cte => nfsDoCte(cte)} />
          <Column
            style={tableCellCentered(60)}
            body={cte => botaoRemover('ctesRemovidos', cte.cte_id)}
          />
        </DataTable>
      )
    return (
      <DataTable value={ctesSelecionados} {...propsTabelaDocumentos}>
        <Column field="numero" header="CTe" style={tableCellCentered(90)} />
        <Column field="client_name" header="Cliente" />
        <Column field="client_city" header="Cidade" style={tableCellCentered(130)} />
        <Column field="company_name" header="Empresa" />
        <Column field="identifier" header="NFs" style={tableCellCentered(110)} />
        <Column style={tableCellCentered(60)} body={cte => botaoRemover('ctesRemovidos', cte.id)} />
      </DataTable>
    )
  }

  const resumoDocumentos = () => {
    if (!modoCte)
      return `${nfsSelecionadas.length} de ${nfsRota.length} NF-e(s) da rota serão manifestadas neste MDFe.`
    const semCte =
      origem === 'nfe'
        ? nfsRota.filter(nf => !nf.mdfe_vigente && !(nf.ctes_ids || []).length).length
        : 0
    return (
      `${ctesSelecionados.length} CTe(s) serão manifestados neste MDFe.` +
      (semCte ? ` ${semCte} NF(s) da rota sem CTe autorizado ficam fora dele.` : '')
    )
  }

  const avisoNfsSemChave = () =>
    `NFs sem chave de acesso não podem ser vinculadas ao MDFe: ${nfsSemChave
      .map(nf => nf.identifier)
      .join(', ')}.`

  // Render
  const modalMdfe = (
    <CustomModal
      isVisible={isVisible}
      header={'Emitir MDFe'}
      style={{ width: '90vw', maxWidth: 900 }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
      onClose={onClose}
    >
      <form className="p-grid">
        {origem === 'nfe' && fleetId && onMdfeVinculado && (
          <div
            className="p-col-12"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 10,
            }}
          >
            {notaSecaoOpcional(
              'O MDFe desta viagem já foi emitido fora da rota? Vincule-o em vez de emitir outro.',
            )}
            <Btn onClick={() => setModalVincularMdfe(true)}>Vincular MDFe à rota</Btn>
          </div>
        )}
        {mdfesAnteriores.map(mdfe => (
          <div className="p-col-12" key={mdfe.id} style={{ paddingTop: 0, paddingBottom: 0 }}>
            {notaAviso(avisoMdfeAnterior(mdfe))}
          </div>
        ))}

        <div className="p-col-12">
          <CustomTabView activeIndex={abaAtiva} onTabChange={setAbaAtiva}>
            <TabPanel header="Dados">
              <div className="p-grid">
                {/* Rota */}
                <div className="p-col-12">
                  <SectionTitle title="Rota" />
                </div>
                {modoCte && emissorMdfe && (
                  <div className="p-col-12" style={{ fontSize: '0.85rem' }}>
                    Emissor (dos CTes): <strong>{emissorMdfe.razao_social}</strong> — Tipo de
                    emitente: {NOMES_TIPO_EMITENTE_MDFE[1]}
                  </div>
                )}
                {origem === 'nfe' && !modoCte && (
                  <>
                    <div className="p-md-6 p-col-12">
                      <CustomDropdown
                        optionLabel="razao_social"
                        options={emissores}
                        value={state.emissor}
                        label="Emissor:*"
                        filter={true}
                        onChange={value => {
                          setState(prevState => ({
                            ...prevState,
                            emissor: value,
                            tipo_emitente: null,
                          }))
                        }}
                      />
                    </div>
                    <div className="p-md-6 p-col-12">
                      <CustomDropdown
                        optionLabel="label"
                        options={TIPOS_EMITENTE_NFE}
                        value={state.tipo_emitente}
                        label="Tipo de Emitente:*"
                        onChange={value =>
                          setState(prevState => ({ ...prevState, tipo_emitente: value }))
                        }
                      />
                    </div>
                  </>
                )}
                <div className="p-md-6 p-col-12">
                  <CustomDropdown
                    optionLabel="vehicle_badge"
                    options={veiculos}
                    value={state.veiculo}
                    label="Veículo:*"
                    filter={true}
                    onChange={value => {
                      setState(prevState => ({
                        ...prevState,
                        veiculo: value,
                        motorista:
                          (motoristas && motoristas.find(m => m.id === value.default_driver_id)) ||
                          prevState.motorista,
                      }))
                    }}
                  />
                </div>
                <div className="p-md-6 p-col-12">
                  <CustomDropdown
                    optionLabel="name"
                    options={motoristas}
                    value={state.motorista}
                    label="Condutor:*"
                    filter={true}
                    onChange={value => {
                      setState(prevState => ({ ...prevState, motorista: value }))
                    }}
                  />
                </div>
                {opcoesRota.length === 1 && (
                  <div className="p-col-12" style={{ fontSize: '0.8rem', color: '#888' }}>
                    Veículo da rota dos CTes selecionados: {opcoesRota[0].veiculo_placa} —{' '}
                    {opcoesRota[0].motorista_nome}
                  </div>
                )}
                {opcoesRota.length > 1 && (
                  <div className="p-col-12" style={{ fontSize: '0.8rem', color: '#e67e22' }}>
                    Atenção: os CTes selecionados foram roteirizados em veículos/viagens diferentes
                    ({opcoesRota.map(o => `${o.veiculo_placa} — ${o.motorista_nome}`).join('; ')}).
                    Selecione o veículo e o condutor que realmente farão o transporte.
                  </div>
                )}
                <div className="p-md-4 p-col-12">
                  <CustomDropdown
                    optionLabel="label"
                    options={TIPOS_CARGA}
                    value={state.tipo_carga}
                    label="Tipo de Carga:*"
                    filter={true}
                    onChange={value => {
                      setState(prevState => ({ ...prevState, tipo_carga: value }))
                    }}
                  />
                </div>
                <div className="p-md-4 p-col-12">
                  <CustomDropdown
                    optionLabel="name"
                    options={ufs}
                    value={state.uf_inicio}
                    label="Estado Inicial:*"
                    filter={true}
                    onChange={value => {
                      setState(prevState => ({ ...prevState, uf_inicio: value }))
                    }}
                  />
                </div>
                <div className="p-md-4 p-col-12">
                  <CustomDropdown
                    optionLabel="name"
                    options={ufs}
                    value={state.uf_fim}
                    label="Estado Final:*"
                    filter={true}
                    onChange={value => {
                      setState(prevState => ({ ...prevState, uf_fim: value }))
                    }}
                  />
                </div>

                {/* Seguro - opcional para transportador de carga própria (2) */}
                <div className="p-col-12" style={{ marginTop: 10 }}>
                  <SectionTitle title={seguroObrigatorio ? 'Seguro' : 'Seguro (Opcional)'} />
                  {!seguroObrigatorio && (
                    <div style={{ marginTop: 5 }}>
                      {notaSecaoOpcional(
                        'Transportador de carga própria pode emitir sem seguro. ' +
                          'Se um campo for preenchido, os campos com * passam a ser obrigatórios.',
                      )}
                    </div>
                  )}
                </div>
                <div className="p-md-4 p-col-12">
                  <CustomDropdown
                    optionLabel="razao_social"
                    options={seguradoras}
                    value={state.seguradora}
                    label="Seguradora:*"
                    filter={true}
                    showClear={true}
                    onChange={value => {
                      setState(prevState => ({ ...prevState, seguradora: value }))
                    }}
                  />
                </div>
                <div className="p-md-4 p-col-12">
                  <InputText
                    label="Número Apólice:*"
                    marginTop={10}
                    value={state.numero_apolice}
                    onChange={value => {
                      setState(prevState => ({ ...prevState, numero_apolice: value.slice(0, 20) }))
                    }}
                  />
                </div>
                <div className="p-md-4 p-col-12">
                  <InputText
                    label="Número Averbação:"
                    marginTop={10}
                    value={state.numero_averbacao}
                    onChange={value => {
                      setState(prevState => ({
                        ...prevState,
                        numero_averbacao: value.slice(0, 40),
                      }))
                    }}
                  />
                  <div style={{ marginTop: 3, textAlign: 'left' }}>
                    {notaSecaoOpcional(
                      'Caso o campo não seja preenchido, será informado o valor de contingência 99999 (Deliberação ANTT 325/2017)',
                    )}
                  </div>
                </div>
                <div className="p-md-5 p-col-12">
                  <div style={{ marginTop: 10, textAlign: 'left' }}>
                    <label style={{ fontSize: '0.8rem', color: '#14B0BF', display: 'block' }}>
                      Responsável pelo Seguro:*
                    </label>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        marginTop: 3,
                        height: 30,
                      }}
                    >
                      {RESPONSAVEIS_SEGURO.map(opcao => (
                        <label
                          key={opcao.value}
                          style={{
                            marginBottom: 0,
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <input
                            type="radio"
                            name="responsavel-seguro"
                            checked={state.responsavel_seguro === opcao.value}
                            onChange={() =>
                              setState(prevState => ({
                                ...prevState,
                                responsavel_seguro: opcao.value,
                                seguro_documento_responsavel: '',
                              }))
                            }
                            style={{ marginRight: 4 }}
                          />
                          {opcao.label}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                {state.responsavel_seguro === '2' && (
                  <div className="p-md-7 p-col-12">
                    {renderCampoDocumentoResponsavel({
                      radioName: 'seguro-documento',
                      label:
                        state.seguro_tipo_documento_responsavel === 'cnpj'
                          ? 'CNPJ do Responsável pelo Seguro:*'
                          : 'CPF do Responsável pelo Seguro:*',
                      tipo: state.seguro_tipo_documento_responsavel,
                      documento: state.seguro_documento_responsavel,
                      onChangeTipo: value =>
                        setState(prevState => ({
                          ...prevState,
                          seguro_tipo_documento_responsavel: value,
                          seguro_documento_responsavel: '',
                        })),
                      onChangeDocumento: value =>
                        setState(prevState => ({
                          ...prevState,
                          seguro_documento_responsavel: value,
                        })),
                    })}
                  </div>
                )}

                {/* Vale Pedágio - opcional, tudo-ou-nada */}
                <div className="p-col-12" style={{ marginTop: 10 }}>
                  <SectionTitle title="Vale Pedágio (Opcional)" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 10,
                      marginTop: 5,
                    }}
                  >
                    {notaSecaoOpcional(
                      'Se um campo for preenchido, os campos com * passam a ser obrigatórios. ' +
                        'Os dados vêm do comprovante de compra do vale-pedágio (fornecedora Sem Parar, Veloe, ConectCar etc.).',
                    )}
                    <Btn onClick={onLimparValePedagio}>Limpar</Btn>
                  </div>
                </div>
                <div className="p-md-5 p-col-12">
                  <InputNumeroInteiro
                    label="CNPJ Empresa Fornecedora:*"
                    marginTop={10}
                    format="##.###.###/####-##"
                    value={state.vale_pedagio.cnpj_empresa_fornecedora}
                    placeholder="00.000.000/0000-00"
                    onChange={value => onValePedagioChange('cnpj_empresa_fornecedora', value)}
                  />
                </div>
                <div className="p-md-7 p-col-12">
                  {renderCampoDocumentoResponsavel({
                    radioName: 'vale-pedagio-documento',
                    label:
                      state.vale_pedagio.tipo_documento_responsavel === 'cnpj'
                        ? 'CNPJ do Responsável pelo Pagamento:*'
                        : 'CPF do Responsável pelo Pagamento:*',
                    tipo: state.vale_pedagio.tipo_documento_responsavel,
                    documento: state.vale_pedagio.documento_responsavel,
                    onChangeTipo: value => {
                      onValePedagioChange('tipo_documento_responsavel', value)
                      onValePedagioChange('documento_responsavel', '')
                    },
                    onChangeDocumento: value => onValePedagioChange('documento_responsavel', value),
                  })}
                </div>
                <div className="p-md-4 p-col-12">
                  <InputText
                    label="Número do Comprovante (IDVPO):*"
                    marginTop={10}
                    value={state.vale_pedagio.numero_comprovante_compra}
                    placeholder="até 20 dígitos"
                    onChange={value =>
                      onValePedagioChange('numero_comprovante_compra', somenteDigitos(value, 20))
                    }
                  />
                </div>
                <div className="p-md-2 p-col-12">
                  <InputNumeroDecimal
                    label="Valor:*"
                    marginTop={10}
                    value={state.vale_pedagio.valor_vale_pedagio}
                    onChange={value => onValePedagioChange('valor_vale_pedagio', value)}
                  />
                </div>
                <div className="p-md-3 p-col-12">
                  <CustomDropdown
                    optionLabel="label"
                    options={TIPOS_VALE_PEDAGIO}
                    value={state.vale_pedagio.tipo_vale_pedagio}
                    label="Tipo:"
                    showClear={true}
                    onChange={value => onValePedagioChange('tipo_vale_pedagio', value)}
                  />
                </div>
                <div className="p-md-3 p-col-12">
                  <CustomDropdown
                    optionLabel="label"
                    options={CATEGORIAS_COMBINACAO_VEICULAR}
                    value={state.vale_pedagio.categoria_combinacao_veicular}
                    label="Categoria Combinação Veicular:"
                    showClear={true}
                    onChange={value => onValePedagioChange('categoria_combinacao_veicular', value)}
                  />
                </div>

                {/* CIOT - opcional até a SEFAZ passar a exigir (NT MDFe 2026.001) */}
                <div className="p-col-12" style={{ marginTop: 10 }}>
                  <SectionTitle title="CIOT (Opcional)" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: 5,
                    }}
                  >
                    {notaSecaoOpcional(
                      'Código gerado na ANTT/Instituição de Pagamento antes da viagem. ' +
                        'Se um CIOT for informado, os campos com * passam a ser obrigatórios. ' +
                        'Em "Emitir e Vincular CIOT" o próprio sistema gera e declara o CIOT na ANTT.',
                    )}
                    <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                      <Btn onClick={onEmitirVincularCiot}>Emitir e Vincular CIOT</Btn>
                      <Btn onClick={onAdicionarCiot}>
                        <FaPlus style={{ marginRight: 5 }} size={10} />
                        Adicionar CIOT
                      </Btn>
                    </div>
                  </div>
                </div>
                {state.ciots.map((ciot, index) => (
                  <React.Fragment key={index}>
                    <div className="p-md-4 p-col-12">
                      <InputText
                        label={`CIOT ${index + 1}:*`}
                        marginTop={10}
                        value={ciot.ciot}
                        placeholder="12 dígitos"
                        disabled={Boolean(ciot.ciot_id)}
                        onChange={value => onCiotChange(index, 'ciot', somenteDigitos(value, 12))}
                      />
                      {ciot.ciot_id && (
                        <div style={{ marginTop: 3, textAlign: 'left' }}>
                          {notaSecaoOpcional(
                            'Declarado na ANTT pelo sistema; responsável = quem declarou',
                          )}
                        </div>
                      )}
                    </div>
                    <div className="p-md-7 p-col-12">
                      {renderCampoDocumentoResponsavel({
                        radioName: `ciot-documento-${index}`,
                        label:
                          ciot.tipo_documento_responsavel === 'cnpj'
                            ? 'CNPJ do Responsável:*'
                            : 'CPF do Responsável:*',
                        tipo: ciot.tipo_documento_responsavel,
                        documento: ciot.documento_responsavel,
                        disabled: Boolean(ciot.ciot_id),
                        onChangeTipo: value => {
                          onCiotChange(index, 'tipo_documento_responsavel', value)
                          onCiotChange(index, 'documento_responsavel', '')
                        },
                        onChangeDocumento: value =>
                          onCiotChange(index, 'documento_responsavel', value),
                      })}
                    </div>
                    <div
                      className="p-md-1 p-col-12"
                      style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 15 }}
                    >
                      <FaTrash
                        style={{ cursor: 'pointer' }}
                        color="red"
                        onClick={() => onRemoverCiot(index)}
                      />
                    </div>
                  </React.Fragment>
                ))}
                {!ciotDispensado && (
                  <div className="p-col-12">
                    {notaAviso(
                      'Em 01/06/2026 o CIOT passou a ser obrigatório na emissão de MDFe e a sua omissão ' +
                        'poderá resultar em aplicação de multa. A partir de 23/11/2026, se o campo não for ' +
                        'preenchido, a SEFAZ passará a rejeitar a emissão.',
                    )}
                  </div>
                )}

                <div className="p-col-12">
                  <CustomInputTextArea
                    label="Observações"
                    marginTop={10}
                    rows={3}
                    value={state.observacoes || ''}
                    onChange={value =>
                      setState(prevState => ({ ...prevState, observacoes: value }))
                    }
                  />
                </div>
              </div>
            </TabPanel>
            {(rotaInfo || origem === 'cte') && (
              <TabPanel header={`Documentos Associados (${linhasDocumentos.length})`}>
                <div className="p-grid">
                  {origem === 'nfe' && ctesRotaLivres.length > 0 && (
                    <div
                      className="p-col-12"
                      style={{ display: 'flex', gap: 20, alignItems: 'center', fontSize: '0.9rem' }}
                    >
                      <span style={{ fontSize: '0.8rem', color: '#14B0BF' }}>Manifestar por:</span>
                      {[
                        { value: 'nfe', label: 'Notas fiscais da rota' },
                        { value: 'cte', label: `CTes das notas (${ctesRotaLivres.length})` },
                      ].map(opcao => (
                        <label
                          key={opcao.value}
                          style={{
                            marginBottom: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <input
                            type="radio"
                            name="modo-documentos"
                            checked={documentos.modo === opcao.value}
                            onChange={() => onModoDocumentosChange(opcao.value)}
                            style={{ marginRight: 4 }}
                          />
                          {opcao.label}
                        </label>
                      ))}
                    </div>
                  )}
                  <div className="p-col-12">{renderTabelaDocumentos()}</div>
                  <div
                    className="p-col-12"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    {notaSecaoOpcional(
                      resumoDocumentos() +
                        (qtdRemovidos ? ` ${qtdRemovidos} removido(s) deste MDFe.` : ''),
                    )}
                    {qtdRemovidos > 0 && <Btn onClick={onRestaurarDocumentos}>Restaurar todos</Btn>}
                  </div>
                  {!modoCte && nfsSemChave.length > 0 && (
                    <div className="p-col-12">{notaAviso(avisoNfsSemChave())}</div>
                  )}
                  {!modoCte && nfsEmOutroMdfe.length > 0 && (
                    <div className="p-col-12">
                      {notaSecaoOpcional(
                        `As NFs ${nfsEmOutroMdfe
                          .map(nf => `${nf.identifier} (MDFe ${nf.mdfe_vigente})`)
                          .join(', ')} já estão vinculadas a MDFe vigente e ficam fora deste.`,
                      )}
                    </div>
                  )}
                </div>
              </TabPanel>
            )}
          </CustomTabView>
        </div>

        <div className="p-col-12" style={{ display: 'flex', justifyContent: 'end' }}>
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )

  // Fora do Dialog do MDFe: o transform do .p-dialog prenderia um Dialog aninhado
  return (
    <>
      {modalMdfe}
      <ModalVincularCiot
        visible={isVisible && modalCiot}
        emissor={emissorMdfe}
        emissores={emissores || []}
        contexto={contextoCiot}
        numerosJaInformados={state.ciots.map(ciot => ciot.ciot).filter(Boolean)}
        onClose={() => setModalCiot(false)}
        onVinculado={onCiotVinculado}
        onError={onError}
      />
      {origem === 'nfe' && fleetId && onMdfeVinculado && (
        <ModalVincularMdfeRota
          visible={isVisible && modalVincularMdfe}
          fleetId={fleetId}
          placa={rotaInfo ? rotaInfo.veiculo_placa : ''}
          onClose={() => setModalVincularMdfe(false)}
          onVinculado={mdfe => {
            setModalVincularMdfe(false)
            onMdfeVinculado(mdfe)
          }}
          onError={onError}
        />
      )}
    </>
  )
}
